import LargeGridIcon from '~/assets/icons/LargeGrid';
import SmallGridIcon from '~/assets/icons/SmallGrid';
import Tracked from '~/components/Tracked';

type Props = {
  gridSize: 'small' | 'large';
  setGridSize: React.Dispatch<React.SetStateAction<'small' | 'large'>>;
};

const AdjustableGridToggle = ({ gridSize, setGridSize }: Props) => {
  const targetGridSize = gridSize === 'small' ? 'large' : 'small';

  return (
    <Tracked.Button
      className="cursor-pointer"
      onClick={() => setGridSize(targetGridSize)}
      pagePosition="Top Bar"
      name={`GRID_SIZE_TOGGLE_${targetGridSize.toUpperCase()}`}
      variant="none"
    >
      {gridSize === 'small' ? <SmallGridIcon /> : <LargeGridIcon />}
    </Tracked.Button>
  );
};

export default AdjustableGridToggle;
